import { GridItemWrapper } from "../styles/Grid.style";

const GridItem = ({ forwardedRef, ...props }) => {
    return(
        <GridItemWrapper ref={forwardedRef} {...props} />
    )
};

export default GridItem;